function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#18988B;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "321,125 341.8,47.4 298.1,125 260.7,125 258.6,46.7 237.7,125 192.6,125 225,4.1 293,4.1 293.9,70  330.2,4.1 398.4,4.1 366,125  "
}), React.createElement("path", {
  className: "st0",
  d: "M455,129.2c-15.1,0-46.5,0-60.7-18.3c-8.4-10.8-9.9-26.4-4.5-46.6C407,0,464.4,0,488.8,0 c15.1,0,46.4,0,60.7,18.4c8.4,10.8,9.9,26.4,4.5,46.6C536.8,129.2,479.5,129.2,455,129.2z M480.9,32.3c-20.4,0-33.1,10.7-39,32.6 c-3.1,11.4-2.6,19.8,1.5,25c3.6,4.6,10.1,6.9,19.5,6.9c20.4,0,33.1-10.7,39-32.6c3.1-11.4,2.6-19.8-1.5-25 C496.9,34.6,490.3,32.3,480.9,32.3z"
}), React.createElement("polygon", {
  className: "st0",
  points: "678.6,125 699.7,46 822.5,46 813.3,80.2 739.9,80.2 737.2,90.4 816.3,90.4 807,125  "
}), React.createElement("polygon", {
  className: "st0",
  points: "829.9,35.5 831,35.5 839.4,4.1 838.3,4.1 832.3,4.1 660.9,4.1 615.9,77.8 610.4,4.1 556.4,4.1  578.1,125 628.9,125 693,35.5 825.3,35.5  "
})), React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "43.1,125 0,125 18.7,55.1 61.9,55.1  "
}), React.createElement("polygon", {
  className: "st0",
  points: "90.5,125 47.4,125 66.1,55 109.2,55  "
}), React.createElement("polygon", {
  className: "st0",
  points: "137.8,125 94.7,125 118.8,35.1 161.9,35.1  "
}), React.createElement("polygon", {
  className: "st0",
  points: "185.1,125 142,125 169.3,22.7 212.5,22.7  "
})));

var SvgMoveLogoGreen = function SvgMoveLogoGreen(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 839.4 129.2",
    style: {
      enableBackground: "new 0 0 839.4 129.2"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMoveLogoGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/move-logo-green.a71109d9.svg";
export { ForwardRef as ReactComponent };